import React, { useState } from 'react';
import { Modal, Button,  Dropdown, ButtonGroup } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaPencilAlt } from 'react-icons/fa';

const InternalRemakeCase = ({ showModal, handleClose }) => {
  const [selectedRole, setSelectedRole] = useState('');
  const [checked, setChecked] = useState(false);
  const [checking, setChecking] = useState(false);
  const [checkeded, setCheckeded] = useState(false);
  const [checkeding, setCheckeding] = useState(false);
  const [checkerr, setCheckederr] = useState(false);
  const [check, setCheck] = useState(false);
  const [checkee, setCheckee] = useState(false);
  const [checkeor, setCheckeor] = useState(false);
  const [checker, setChecker] = useState(false);

  const containerStyled = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    margin: '20px 0',
    flexDirection: 'row',
  };

  const dropdownStyling = {
    padding: '3px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '5px',
    outline: 'none',
    color: '#333',
    width: '200px',
    height: '31px',
    cursor: 'pointer',
    marginLeft: '80px',
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleChanging = (event) => {
    setChecking(event.target.checked);
  };
  const handleChanger = (event) => {
    setChecker(event.target.checked);
  };
  const handleChangeded = (event) => {
    setCheckeded(event.target.checked);
  };
  const handleChangerr = (event) => {
    setCheckederr(event.target.checked);
  };
  const handleChangeding = (event) => {
    setCheckeding(event.target.checked);
  };
  const handleChang = (event) => {
    setCheck(event.target.checked);
  };
  const handleChangee = (event) => {
    setCheckee(event.target.checked);
  };
  const handleChangeor = (event) => {
    setCheckeor(event.target.checked);
  };


  return (
    <Modal show={showModal} onHide={handleClose} dialogClassName="modal-90w" size="lg">
      <Modal.Header closeButton style={{ backgroundColor: '#004aad', borderColor: '#004aad' }}>
        <Modal.Title style={{ color: 'white' }}>Internal Remake of case #30205</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={containerStyled}>
          <b>Reason for remake *</b>
          <select value={selectedRole} onChange={handleRoleChange} style={dropdownStyling}>
            <option value="Select Reason">Select Reason</option>
            <option value="Did not read Rx">Did not read Rx</option>
            <option value="Miscast ring">Miscast ring</option>
            <option value="Model Broken">Model Broken</option>
            <option value="Procelain fracture">Procelain fracture</option>
          </select>
        </div>
        <div><h2>
          Remake Details</h2>
          <div
            style={{
              alignItems: 'center',
              fontSize: '0.9rem',
              marginRight: '20px',
              gap: '50px',
              backgroundColor: '#f2f2f2',
            }}
          >
            <br />
            <span style={{ padding: '15px' }}>
              <b>Case Tasks</b>
            </span>
            <p style={{ padding: '17px' }}>
              MULTILAYERED SCREW RETAINED ZIRCONIA CROWN (Hira Lab Components)
            </p>
            <TaskCheckbox label="COMPONENT REVIEW" checked={checked} onChange={handleChange} />
            <TaskCheckbox label="GINGIVA" checked={checking} onChange={handleChanging} />
            <TaskCheckbox label="MODEL MAKING" checked={checker} onChange={handleChanger} />
            <TaskCheckbox label="SCANNING" checked={checkeded} onChange={handleChangeded} />
            <TaskCheckbox label="DESIGNING CROWN & MODELS" checked={checkerr} onChange={handleChangerr} />
            <TaskCheckbox label="MILLING & COLORING" checked={checkeding} onChange={handleChangeding} />
            <TaskCheckbox label="SEATING ON GINGIVA" checked={check} onChange={handleChang} />
            <TaskCheckbox label="BUILD UP/STAIN & GLAZE" checked={checkee} onChange={handleChangee} />
            <TaskCheckbox label="QUALITY CONTROL" checked={checkeor} onChange={handleChangeor} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ backgroundColor: '#004aad', borderColor: '#004aad' }} onClick={handleClose}>
          Cancel
        </Button>
        <Button style={{ backgroundColor: '#004aad', borderColor: '#004aad' }} onClick={handleClose}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const TaskCheckbox = ({ label, checked, onChange }) => (
  <div style={{ padding: '10px 0' }}>
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      style={{ padding: '15px', marginLeft: '18px' }}
    />
    <label style={{ padding: '10px' }}>{label}</label>
    <Dropdown as={ButtonGroup}>
      <Button style={{ border: '1px solid', backgroundColor: '#004aad' }}>
        <FaPencilAlt />
      </Button>
    </Dropdown>
  </div>
);

export default InternalRemakeCase;
